export const GET_MCCS = gql`
    query GetMCCS($input: FilterMCCsInput, $page: PageFilters) {
        mccs(input: $input, page: $page) {
            total
            page
            pageSize
            data {
                id
                name
                code
                risk
                description
                formattedDescription {
                    text
                    type
                }
                documents
                formattedDocuments {
                    text
                    type
                }
            }
        }
    }
`;

export const GET_MCC = gql`
    query GetMCC($id: Int!) {
        mcc(id: $id) {
            id
            name
            code
            risk
            description
            formattedDescription {
                text
                type
            }
            documents
            formattedDocuments {
                text
                type
            }
        }
    }
`;
